import HttpHelper from "../../helpers/httpHelper";

const SHOPPING_API_URL = process.env.REACT_APP_SHOPPING_API_URL;
const USER_API_URL = process.env.REACT_APP_USER_API_URL;

class ShoppingAPI {
    static GetAccessToken(req) {
        let url = `${SHOPPING_API_URL}/order/access/${req}`;
        
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static GetPaymentLinks(req) {
        let url = `${SHOPPING_API_URL}/order/links/${req}`;
        
        return HttpHelper.httpRequest(url, "GET", {});
    }
    //#region Cart
    static AddItemToCart(req) {
        let url = `${SHOPPING_API_URL}/cart/add-item`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static GetCart(req) {
        let url = `${SHOPPING_API_URL}/cart`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static UpdateCart(req) {
        let url = `${SHOPPING_API_URL}/cart`;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    //#endregion

    //#region Admin

    //#region Order

    static GetOrderList(req) {
        let url = `${SHOPPING_API_URL}/order`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static GetOrderById(id) {
        let url = `${SHOPPING_API_URL}/order/` + id;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static UpdateOrder(req) {
        let url = `${SHOPPING_API_URL}/order/` + req.id;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static CreateOrder(req) {
        let url = `${SHOPPING_API_URL}/order`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    //#endregion

    //#region Order Group

    static CreateOrderGroup(req) {
        let url = `${SHOPPING_API_URL}/order-group`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    //#endregion

    //#region Payment

    static CreateSubscription(req) {
        let url = `${SHOPPING_API_URL}/payment/subscription`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static CreateVIPSubscription(req) {
        let url = `${SHOPPING_API_URL}/payment/vip-circle`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static CreateUpgradeAccountSubscription(req) {
        let url = `${SHOPPING_API_URL}/payment/upgrade-account`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static GetPlanDetails(req) {
        let url = `${SHOPPING_API_URL}/payment/upgrade-plan`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    //#endregion

    //#region Payment Config

    static GetPaymentConfig(req) {
        let url = `${SHOPPING_API_URL}/payment-config`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static GetPaymentPayoutConfig(req) {
        let url = `${SHOPPING_API_URL}/payment-config/payout`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static GetPaymentBalance(req) {
        let url = `${SHOPPING_API_URL}/payment/balance`;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    //#endregion

    //#region Product

    static GetProductses(req) {
        let url = `${SHOPPING_API_URL}/products`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static GetProducts(req) {
        let url = `${SHOPPING_API_URL}/product`;
        if (req) {
            url = `${SHOPPING_API_URL}/product?id=` + req;
        }
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static GetAnonymousProducts(req) {
        let url = `${SHOPPING_API_URL}/products/` + req;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static GetProductByIds(req) {
        let url = `${SHOPPING_API_URL}/product/list-by-ids`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static GetAnonymousProductByIds(req) {
        let url = `${SHOPPING_API_URL}//products/list-by-ides`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static CreateProduct(req) {
        let url = `${SHOPPING_API_URL}/product`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static UpdateProduct(req) {
        let url = `${SHOPPING_API_URL}/product/` + req.id;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static GetProductById(req) {
        let url = `${SHOPPING_API_URL}/product/` + req.id;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static DeleteProductById(req) {
        let url = `${SHOPPING_API_URL}/product/` + req.id;
        return HttpHelper.httpRequest(url, "DELETE", {}, req);
    }

    static UpdateProductStatus(req) {
        let url = `${SHOPPING_API_URL}/product/` + req.id;
        return HttpHelper.httpRequest(url, "PATCH", {}, req);
    }

    //#endregion

    //#region Category

    static GetCategories(req) {
        let url = `${SHOPPING_API_URL}/product-category`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static CreateCategory(req) {
        let url = `${SHOPPING_API_URL}/product-category`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static UpdateCategory(req) {
        let url = `${SHOPPING_API_URL}/product-category` + req.id;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static GetCategoryById(req) {
        let url = `${SHOPPING_API_URL}/product-category` + req.id;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static DeleteCategoryById(req) {
        let url = `${SHOPPING_API_URL}/product-category` + req.id;
        return HttpHelper.httpRequest(url, "DELETE", {}, req);
    }

    //#endregion

    //#region Bank Account

    static UpdateCard(req) {
        let url = `${SHOPPING_API_URL}/payment/bank-account`;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static AddCard(req) {
        let url = `${SHOPPING_API_URL}/payment/bank-account`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static DeleteCard(req) {
        let url = `${SHOPPING_API_URL}/payment/bank-account`;
        return HttpHelper.httpRequest(url, "DELETE", {}, { bid: req });
    }

    static GetBankAccounts(req) {
        let url = `${USER_API_URL}/bank-account`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static CreateBankAccount(req) {
        let url = `${USER_API_URL}/bank-account`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }
    static UpdateBankAccount(req) {
        let url = `${USER_API_URL}/bank-account/` + req._id;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static DeleteBankAccount(req) {
        let url = `${USER_API_URL}/bank-account`;
        return HttpHelper.httpRequest(url, "DELETE", {}, req);
    }

    //#endregion

    //#region Transactions

    static GetTransactions(req) {
        let url = `${SHOPPING_API_URL}/transaction` + req;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static GetUserTransactions(req) {
        let url = `${SHOPPING_API_URL}/user/transaction` + req;
        return HttpHelper.httpRequest(url, "GET", {});
    }

    static RequestWithdrawal(req) {
        let url = `${SHOPPING_API_URL}/transaction/request`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    //#endregion

    static GetReviews(req) {
        let url = `${SHOPPING_API_URL}/review`;
        return HttpHelper.httpRequest(url, "GET", {}, req);
    }

    static CreateReview(req) {
        let url = `${SHOPPING_API_URL}/review`;
        return HttpHelper.httpRequest(url, "POST", {}, req);
    }

    static UpdateReview(req) {
        let url = `${SHOPPING_API_URL}/review/` + req._id;
        return HttpHelper.httpRequest(url, "PUT", {}, req);
    }

    static DeleteReview(req) {
        let url = `${SHOPPING_API_URL}/review`;
        return HttpHelper.httpRequest(url, "DELETE", {}, req);
    }
}

export default ShoppingAPI;
